import "../styles/tailwind.css";
import Router from "next/router";
import NProgress from "nprogress";
import Layout from "../components/Layout";

let previousPath = null;

function handleRouteChange(url) {
  const pathname = url.split("?")[0];

  if (previousPath && previousPath !== pathname) NProgress.start();
  previousPath = pathname;
}

Router.events.on("routeChangeStart", handleRouteChange);
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

export default function CustomApp({ Component, pageProps }) {
  return (
    <Layout pagesData={pageProps.pagesData}>
      <Component {...pageProps} />
    </Layout>
  );
}
